var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6325 10.5479L7.75494 12.729L3.8774 10.5479V8.24342L2.76953 7.62793V11.1957L7.75494 14L12.7403 11.1957V7.62793L11.6325 8.24342V10.5479Z",
    fill: "#0E0F1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75507 0L0 4.02114V4.98132L7.75507 9.28958L14.4023 5.59681V8.65601H15.5101V4.02114L7.75507 0ZM13.2944 4.94493L12.1865 5.56039L7.75507 8.02245L3.3236 5.56039L2.21574 4.94493L1.44788 4.51833L7.75507 1.24794L14.0623 4.51833L13.2944 4.94493Z",
    fill: "#0E0F1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.682a8e7d309fa8d6c875fc2f2e26b549.svg";
export { ForwardRef as ReactComponent };